<template>
  <header class="main-menu-bar" v-if="!hidden">
    <menubar ref="menu" :model="items">
      <template #end>
        <span @click="hide"><i class="pi pi-times"></i></span>
      </template>
    </menubar>
  </header>
</template>

<script>
import Menubar from 'primevue/menubar'
import HandlesNavigation from '../../mixins/handles-navigation'
export default {
  name: 'MainMenuBar',
  mixins: [
    HandlesNavigation
  ],
  components: {
    Menubar
  },
  data: function () {
    return {
      hidden: false
    }
  },
  methods: {
    hide () {
      this.hidden = true
    },
    toggle (event) {
      this.$refs.menu.toggle(event)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/nav/MainMenuBar.vue